import { Button } from "@mui/material"
import { useState } from "react"
import AddInventory from "../modals/AddInventory"
import {
  getAllInventories,
  getInventoryFilters,
  getInventorySort,
} from "../../api"
import ListData from "../common/ListData"
import AddRoundedIcon from "@mui/icons-material/AddRounded"
import InventoryCard from "../cards/InventoryCard"

const Inventories = ({data}) => {

  const [addInventoryModal, setAddInventoryModal] = useState(false)

  const [fetchData, setFetchData] = useState(false)

  const CTA = () => (
    <Button
    onClick={() => setAddInventoryModal(true)}
      variant="contained"
      startIcon={<AddRoundedIcon />}
    >
      Add Inventory
    </Button>
  )

  return (
    <>
      <ListData
        getFilters={getInventoryFilters}
        getSort={getInventorySort}
        getAllData={getAllInventories}
        initialFilters={{}}
        HeaderRight={CTA}
        Card={InventoryCard}
      />
      <AddInventory
        isOpen={addInventoryModal}
        close={() => setAddInventoryModal(false)}
        data={data}
      />
    </>
  )
}

export default Inventories
